'use client';

export interface UTM {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
}

export const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
] as const;

// type UTMKey = (typeof UTM_KEYS)[number];

export function saveUtmCookies() {
  // if (typeof window === 'undefined') return;

  // const params = new URLSearchParams(window.location.search);
  // const now = new Date();
  // now.setMonth(now.getMonth() + 3);

  // UTM_KEYS.forEach((key) => {
  //   const value = params.get(key);
  //   if (value) {
  //     document.cookie = `${key}=${encodeURIComponent(value)}; path=/; expires=${now.toUTCString()}; SameSite=Lax`;
  //   }
  // });
}

export function getUtmCookies(): Record<string, string> {
  // if (typeof document === 'undefined') return {};

  // const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
  //   const [key, value] = cookie.split('=');
  //   if (UTM_KEYS.includes(key as UTMKey)) {
  //     acc[key] = decodeURIComponent(value);
  //   }
  //   return acc;
  // }, {} as Record<string, string>);

  // return cookies;

  return {};
}

export function clearUtmCookies() {
  // UTM_KEYS.forEach((key) => removeCookie(key));
}

export function addUtmParamsToUrl(url: string): string {
  // if (!url) return url;

  // const [baseUrl, queryString] = url.split('?');
  // const originalQuery = new URLSearchParams(queryString || '');

  // const utmParams = getUtmCookies();

  // Object.entries(utmParams).forEach(([key, value]) => {
  //   if (value && !originalQuery.has(key)) {
  //     originalQuery.set(key, value);
  //   }
  // });

  // const newQueryString = originalQuery.toString();
  // return `${baseUrl}${newQueryString ? `?${newQueryString}` : ''}`;

  return url;
}
